import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Recruitment Reason\n          ")
], -1);
const _hoisted_4 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                What is the reason for recruiting this role? *\n              ", -1);
const _hoisted_6 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_7 = { class: "mt-4 space-y-4" };
const _hoisted_8 = { class: "flex items-start" };
const _hoisted_9 = { class: "h-5 flex items-center" };
const _hoisted_10 = ["checked", "disabled"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitmentReason",
        class: "font-medium text-gray-700"
    }, "Replacement Role")
], -1);
const _hoisted_12 = { class: "flex items-start" };
const _hoisted_13 = { class: "h-5 flex items-center" };
const _hoisted_14 = ["checked", "disabled"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitmentReason",
        class: "font-medium text-gray-700"
    }, "New Candidates")
], -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_17 = { key: 0 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", null, "As you have selected Replacement Role, please provided\n              the information below for the employee who is leaving/moving:\n            ", -1);
const _hoisted_19 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_id",
    class: "block text-sm font-medium text-gray-700"
}, "Employee ID", -1);
const _hoisted_21 = ["value"];
const _hoisted_22 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_name",
    class: "block text-sm font-medium text-gray-700"
}, "Name", -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_jobTitle",
    class: "block text-sm font-medium text-gray-700"
}, "Job Title", -1);
const _hoisted_27 = ["value"];
const _hoisted_28 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_salary",
    class: "block text-sm font-medium text-gray-700"
}, "Salary", -1);
const _hoisted_30 = ["value"];
const _hoisted_31 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                Is this role in budget? *\n              ", -1);
const _hoisted_33 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_34 = { class: "mt-4 space-y-4" };
const _hoisted_35 = { class: "flex items-start" };
const _hoisted_36 = { class: "h-5 flex items-center" };
const _hoisted_37 = ["disabled", "checked"];
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "inBudget",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1);
const _hoisted_39 = { class: "flex items-start" };
const _hoisted_40 = { class: "h-5 flex items-center" };
const _hoisted_41 = ["disabled", "checked"];
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "inBudget",
        class: "font-medium text-gray-700"
    }, "No")
], -1);
const _hoisted_43 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_44 = { class: "col-span-6" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", {
    for: "recovered",
    class: "block text-sm font-medium text-gray-700"
}, "Please outline the business case for recruiting for this vacancy/the impact of not\n                recruting and how the costs will be recovered*", -1);
const _hoisted_46 = ["value"];
const _hoisted_47 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_48 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_5,
                            _createTextVNode(),
                            (_ctx.v$.formData.recruitmentReason.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "\n                * " + _toDisplayString(_ctx.v$.formData.recruitmentReason.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("input", {
                                            id: "radio-button-replacement-role",
                                            value: "Replacement Role",
                                            name: "recruitmentReason",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                            checked: _ctx.formData.recruitmentReason === 'Replacement Role',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.recruitmentReason.$touch()))
                                        }, null, 42, _hoisted_10)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_11
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("input", {
                                                id: "radio-button-candidates",
                                                value: "Candidates",
                                                name: "recruitmentReason",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                                checked: _ctx.formData.recruitmentReason === 'Candidates',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[2] || (_cache[2] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.recruitmentReason.$touch()))
                                            }, null, 42, _hoisted_14)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_15
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_16
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.recruitmentReason === 'Replacement Role')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "employee_id",
                                    value: _ctx.formData.employee_id,
                                    type: "text",
                                    name: "employee_id",
                                    autocomplete: "name",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, null, 40, _hoisted_21)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "employee_name",
                                    value: _ctx.formData.employee_name,
                                    type: "text",
                                    name: "employee_name",
                                    autocomplete: "name",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, null, 40, _hoisted_24)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "employee_jobTitle",
                                    value: _ctx.formData.employee_jobTitle,
                                    type: "text",
                                    name: "employee_jobTitle",
                                    autocomplete: "name",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, null, 40, _hoisted_27)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "employee_salary",
                                    value: _ctx.formData.employee_salary,
                                    type: "text",
                                    name: "employee_salary",
                                    autocomplete: "salary",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, null, 40, _hoisted_30)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_32,
                            _createTextVNode(),
                            (_ctx.v$.formData.inBudget.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "\n                * " + _toDisplayString(_ctx.v$.formData.inBudget.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("input", {
                                                id: "radio-budget-yes",
                                                value: "Yes",
                                                name: "inBudget",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.inBudget === 'Yes',
                                                onChange: _cache[8] || (_cache[8] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                            }, null, 42, _hoisted_37)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_38
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("input", {
                                                id: "radio-budget-no",
                                                value: "No",
                                                name: "inBudget",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.inBudget === 'No',
                                                onChange: _cache[9] || (_cache[9] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                            }, null, 42, _hoisted_41)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_42
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createTextVNode(),
                            _createElementVNode("textarea", {
                                id: "input-role-recovered",
                                value: _ctx.formData.recovered,
                                name: "recovered",
                                autocomplete: "recovered",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                onInput: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                            }, null, 40, _hoisted_46)
                        ])
                    ], 512), [
                        [_vShow, _ctx.formData.inBudget === 'No']
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[12] || (_cache[12] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_48)
            ]))
            : _createCommentVNode("", true)
    ]));
}
